import styled from 'styled-components';

const ContainerReinforcements = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .centerContent {
    width: 100%;
  }
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 24px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 992px) {
    gap: 24px;
  }
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 32px;
`;

const WrapperMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  gap: 16px;
`;

const ImageNoReinforcements = styled.img`
  width: 96px;
  height: 96px;
  flex: none;
  order: 0;
  flex-grow: 0;
`;
export {
  ContainerReinforcements,
  Title,
  Grid,
  WrapperMessage,
  ImageNoReinforcements
};
